module.exports = __webpack_public_path__ + "static/radikal_medium-webfont-809a888cb3f1fa67c0687a224670a29e.woff";